// extracted by css-extract-rspack-plugin
export default {"root":"r43Pxf","custom-icon-button-size":"sPpzTO","customIconButtonSize":"sPpzTO"};